import { useEffect, useState } from "react";
import { useRoute } from "wouter";
import {
  Container,
  Center,
  Loader,
  Stack,
  Title,
  Text,
  Grid,
  Image,
  AspectRatio,
  Paper,
} from "@mantine/core";
import { fetchPublicBundle } from "../api";

export default function PublicBundlePage() {
  const [, params] = useRoute("/b/:id");
  const bundleId = params?.id;

  const [bundle, setBundle] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!bundleId) return;
    setIsLoading(true);
    setNotFound(false);
    fetchPublicBundle(bundleId)
      .then((data) => setBundle(data))
      .catch(() => setNotFound(true))
      .finally(() => setIsLoading(false));
  }, [bundleId]);

  if (isLoading) {
    return (
      <Center mt="xl">
        <Loader size="xl" />
      </Center>
    );
  }
  if (notFound || !bundle) {
    return (
      <Container size="sm" mt="xl">
        <Stack align="center" gap="xs">
          <Title order={3}>Not found</Title>
          <Text c="dimmed">
            This bundle doesn&apos;t exist, or its owner hasn&apos;t shared it.
          </Text>
        </Stack>
      </Container>
    );
  }

  const spans = { base: 6, xs: 6, sm: 4, md: 3, lg: 2 };

  return (
    <Container fluid p="md">
      <Stack>
        <Stack gap={4}>
          <Title order={2}>{bundle.title}</Title>
          {bundle.description && (
            <Text c="dimmed" size="sm">
              {bundle.description}
            </Text>
          )}
          <Text c="dimmed" size="xs">
            {bundle.images.length}{" "}
            {bundle.images.length === 1 ? "photo" : "photos"}
          </Text>
        </Stack>

        {bundle.images.length === 0 ? (
          <Text c="dimmed" ta="center" mt="xl">
            This bundle is empty.
          </Text>
        ) : (
          <Grid gutter={10}>
            {bundle.images.map((img) => (
              <Grid.Col key={img.logicalImageId} span={spans}>
                <Paper
                  withBorder
                  radius="md"
                  style={{ overflow: "hidden", cursor: "zoom-in" }}
                  onClick={() =>
                    img.fullsizeUri && window.open(img.fullsizeUri, "_blank")
                  }
                >
                  <AspectRatio ratio={1}>
                    <Image
                      src={img.thumbnailUri ?? img.fullsizeUri}
                      alt={img.slug ?? bundle.title}
                      fit="cover"
                    />
                  </AspectRatio>
                </Paper>
              </Grid.Col>
            ))}
          </Grid>
        )}
      </Stack>
    </Container>
  );
}
